import React, { useCallback, useEffect, useState } from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Button from "../../../../componentsv2/Button";
import Paper from "../../../../componentsv2/Paper";

import GridContainer from "../../../../componentsv2/GridContainer";
import GridItem from "../../../../componentsv2/GridItem";
import Header from "../../../../components/Header";
import Container from "../../../../componentsv2/Container";
import { Input } from "../../../../componentsv2/Input";
import SelectEstado from "../../../../componentsv2/SelectEstado";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { enqueueSnackbar } from "notistack";
import { api } from "../../../../services/Api";

export default function VisualizarMedico() {
  const history = useHistory();
  const location = useLocation();

  const [nome, setNome] = useState("");
  const [crm, setCrm] = useState("");
  const [estado, setEstado] = useState("");
  const [especialidade, setEspecialidade] = useState("");

  const pegarDadosAgendamento = useCallback(async () => {
    //setLoading(true)
    if (location.state?.row) {
      try {
        const {
          data: { data },
        } = await api.get(`v2/agendaCare/medico_care/${location.state.row.id}`);
        setNome(data.nome);
        setCrm(data.crm);
        setEstado(data.estado);
        setEspecialidade(data.especialidade);
      } catch (error) {
        enqueueSnackbar("Erro ao tentar encontrar os dados.", {
          variant: "error",
        });
      }
    } else {
      history.push("/agendaCare");
    }
    //setLoading(false)
  }, [history, location.state?.row]);

  useEffect(() => {
    pegarDadosAgendamento();
  }, [pegarDadosAgendamento]);

  return (
    <>
      <Header titulo={"Cadastrar Médico"} />
      <Container>
        <Paper
          style={{
            padding: "1rem",
            alignItems: "center",
            display: "flex",
            justfyContent: "center",
            marginTop: "10px",
          }}
          elevation={2}
        >
          <form
            style={{ width: "99%", display: "flex", flexDirection: "column" }}
          >
            <GridContainer>
              <Button>
                <ArrowBackIcon
                  style={{ color: "#003399" }}
                  onClick={() => history.push({ pathname: "/agendaCare" })}
                />
              </Button>
            </GridContainer>
            <GridContainer sx={{ margin: "1px" }} spacing={2} xs={12}>
              <GridItem xs={12} md={3}>
                <Input
                  inputProps={{ readOnly: true }}
                  required
                  fullWidth
                  label="Nome"
                  type="text"
                  variant="standard"
                  value={nome}
                />
              </GridItem>
              <GridItem xs={12} md={3}>
                <Input
                  required
                  fullWidth
                  label="Especialidade"
                  type="text"
                  variant="standard"
                  onChange={(e) => setEspecialidade(e.target.value)}
                  value={especialidade}
                />
              </GridItem>
              <GridItem xs={5} md={3}>
                <Input
                  required
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="CRM"
                  type="text"
                  variant="standard"
                  value={crm}
                />
              </GridItem>
              <GridItem xs={5} md={3}>
                <SelectEstado
                  required
                  inputProps={{ readOnly: true }}
                  value={estado}
                />
              </GridItem>
            </GridContainer>
          </form>
        </Paper>
      </Container>
    </>
  );
}
